import React, { FC } from 'react'
import s from './Tabs.module.scss'

type Props = {
    className?: string
    title: string
}

const Tab: FC<Props> = ({ children, className = '' }) => {
    return <div className={s['content']}>{children}</div>
}

export default Tab
